import React from 'react';
import { BarChart3 } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center mb-4 md:mb-0">
            <BarChart3 className="h-8 w-8 text-blue-500" />
          </div>
          <div className="text-gray-400 text-sm">
            © {new Date().getFullYear()} <a href="https://fractionaldemand.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Fractional Demand</a>. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;